import React, { useState } from "react";
import { Button, Modal, Text } from "@mantine/core";
import { DateInput } from "@mantine/dates";

import useStyles from "./style";
import CloseCircle from "../CloseCircle";

import { FiInfo } from "react-icons/fi";

const VersionUpdateModal = ({ opened, close, loading, handleEdit, handleNewVersion, existingExpirationDate }) => {
  const { classes } = useStyles();
  const [step, setStep] = useState(1);
  const [startDate, setStartDate] = useState(new Date());

  const getDefaultExpirationDate = () =>
    existingExpirationDate && existingExpirationDate !== "null"
      ? new Date(existingExpirationDate)
      : null;

  const [expirationDate, setExpirationDate] = useState(getDefaultExpirationDate());

  const handleClose = () => {
    setStep(1);
    setStartDate(new Date());
    setExpirationDate(getDefaultExpirationDate());
    close();
  };

  const handleCreateNewVersionClick = () => {
    setExpirationDate(getDefaultExpirationDate());
    setStep(2);
  };

  const handleConfirmNewVersion = () => {
    handleNewVersion(startDate, expirationDate);
    setStep(1);
    setStartDate(new Date());
    setExpirationDate(getDefaultExpirationDate());
  };

  return (
    <Modal
      className={classes.confirmationModal}
      opened={opened}
      onClose={handleClose}
      shadow="md"
      overlayProps={{ blur: 3 }}
      radius={"lg"}
      zIndex={1200}
      centered
    >
      <CloseCircle onclose={handleClose} />
      <div className={classes.wrapper}>
        <h2>
          <FiInfo
            size={30}
            color={"orange"}
            style={{ marginBottom: "-7px" }}
          />{" "}
          Info
        </h2>

        {step === 1 && (
          <div className={classes.saveButton}>
            <Button onClick={handleEdit} loading={loading}>Update this medication</Button>
            <Button loading={loading} onClick={handleCreateNewVersionClick}>
              Create new version
            </Button>
          </div>
        )}

        {step === 2 && (
          <>
            <Text fz={14} mt={12} mb={4} color="dimmed">
              Set dates for the new medication version
            </Text>

            <DateInput
              label="Medication Start Date"
              placeholder="mm/dd/yyyy"
              value={startDate}
              onChange={setStartDate}
              mt={10}
              required
              clearable={false}
              styles={{
                input: { backgroundColor: "rgba(242, 242, 242, 0.6)", border: "1px solid #e0e0e0" },
              }}
            />

            <DateInput
              label="Expiration Date"
              placeholder="mm/dd/yyyy"
              value={expirationDate}
              onChange={setExpirationDate}
              mt={12}
              clearable
              styles={{
                input: { backgroundColor: "rgba(242, 242, 242, 0.6)", border: "1px solid #e0e0e0" },
              }}
            />

            {expirationDate && startDate && expirationDate < startDate && (
              <Text fz={13} mt={8} color="red">
                Start date cannot be greater than expiration date.
              </Text>
            )}

            <div className={classes.saveButton} style={{ marginTop: 4 }}>
              <Button variant="default" onClick={() => setStep(1)} disabled={loading}>
                Back
              </Button>
              <Button
                loading={loading}
                disabled={!startDate || (expirationDate && startDate && expirationDate < startDate)}
                onClick={handleConfirmNewVersion}
              >
                Confirm
              </Button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default VersionUpdateModal;
